import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { AppState } from "../app-state";
import { action } from 'typesafe-actions';
import { NpsActionTypes } from "./nps-types";
import { npsApi } from "../../api/talent/nps-service";
import { NpsAnswer } from "../../models/nps.models";


export const fetchShowNps = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(NpsActionTypes.FETCH_SHOW_NPS));
    }
};

export const fetchHideNps = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(NpsActionTypes.FETCH_HIDE_NPS));
    }
};

export const fetchNpsData = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(NpsActionTypes.FETCH_NPS_DATA));
        try {
            const response = await npsApi.fetchNpsData();
            dispatch(action(NpsActionTypes.FETCH_NPS_DATA_SUCCESS, response.data));
        } catch (error) {
            dispatch(action(NpsActionTypes.FETCH_NPS_DATA_ERROR, error));
        }
    }
};

export const submitNps = (answers: NpsAnswer[]) => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        dispatch(action(NpsActionTypes.SUBMIT_NPS_ANSWER));
        dispatch(fetchHideNps());
        try {
            const response = await npsApi.submitNpsAnswer(answers);
            dispatch(action(NpsActionTypes.SUBMIT_NPS_ANSWER_SUCCESS, response.data));
        } catch (error) {
            dispatch(action(NpsActionTypes.SUBMIT_NPS_ANSWER_ERROR, error));
        }
    }
}

export const checkTriggerNps = () => {
    return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
        try {
            const response = await npsApi.checkTriggerNps();
            if (response.data.trigger) {
                dispatch(fetchShowNps());
            }
        } catch (error) {
            console.error(error);
        }
    }
}